/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * That average measured against our own carrying mark.
 */
export type DailyNavDeliveryChangeFromMark = {
  /**
   * Our carrying price per share from the last final valuation, as stored, in `mark_currency`.
   */
  mark: string | null;
  /**
   * The company's cap-table currency, which is what the mark is natively denominated in. Null when unknown, which withholds the percentage.
   */
  mark_currency: string | null;
  /**
   * The mark restated into the firm's reporting currency, and the only converted figure in this payload -- it is our own number, so nothing upstream will restate it for us. Converted at the VALUATION date's rate, not the report day's, because that is the rate the position was booked at. The percentage below therefore includes FX drift since the valuation, which is real exposure rather than noise.
   */
  mark_in_reporting_currency: string | null;
  /**
   * The numerator: the averaged provider price, as reported. Mirrors `price.average`.
   */
  average_price: string | null;
  /**
   * The currency both sides of the division must be in.
   */
  reporting_currency: string;
  /**
   * (average_price / mark_in_reporting_currency) - 1, as a signed fraction. Null whenever `unavailable_reason` is set.
   */
  pct: string | null;
  /**
   * Why `pct` is null: `no_mark` (no prior final valuation carrying a share value), `zero_mark`, `no_price` (no provider published one), `mark_currency_unknown` (nothing says what the mark is in), `fx_unavailable` (the currency is known but no rate was available), or `price_currency_mismatch` (the providers did not report in the firm's currency, and nothing here converts them). Null when a percentage was produced. A reason rather than a flag, so a blank is always explainable.
   */
  unavailable_reason: string | null;
  /**
   * The threshold applied, as a fraction.
   */
  threshold: string | null;
  /**
   * Where `threshold` came from: `company`, `firm`, or `none`.
   */
  threshold_source: DailyNavDeliveryChangeFromMark.threshold_source;
  /**
   * The firm default, carried even when an override won.
   */
  firm_threshold: string | null;
  /**
   * True when abs(pct) is over `threshold`. Absolute: carried far below the market is as much a reason to look as far above.
   */
  exceeded: boolean;
};
export namespace DailyNavDeliveryChangeFromMark {
  /**
   * Where `threshold` came from: `company`, `firm`, or `none`.
   */
  export enum threshold_source {
    COMPANY = 'company',
    FIRM = 'firm',
    NONE = 'none',
  }
}

